class TemplatePropertiesCtrl {
  constructor($scope, $window, $timeout,  $uibModal, TBService, ScriptLoaderService, EventService, TemplateService, TemplateValidationService, FlashService, SchemaService, AuthService) {
    'ngInject';
    Object.assign(this, { $scope, $window, $timeout, $uibModal });
    this.tb = TBService;
    this.es = EventService;
    this.tls = ScriptLoaderService;
    this.ts = TemplateService;
    this.tv = TemplateValidationService;
    this.fs = FlashService;
    this.ss = SchemaService;
    this.as = AuthService;
    this.invalidConn = false;
    this.expandMainProps = false;

    this.loading = "Loading..";
    this.showSuccessMessageHtml = false;
    this.showPasskeyMessageHtml = false;
    this.messages = [];
    this.validationRecords = null;

    this.validationColumns = [ 
      {
        'key': 'id',
        'header': " ",
        'style': { 'width': '25px', 'padding': '8px', 'overflow': 'initial'},
        'format': value => `<i class="fa fa-eye"/>`
      },
      { 'header': 'Title', 'key': 'title' },
      { 
        'header': 'State', 'key': 'state', 
        // 'style': { 'width': '50', 'padding': '8px', 'overflow': 'initial' },
        'format':  (value) => {
          const classes = value != 'Invalid'? "check text-success": "remove text-danger";
          return `<i class="fa fa-${classes}" style="padding: 3px;"/>` ;
        }
      },
      { 'header': 'Count', 'key': 'count', 'style': { "max-width": "80px", "width": "80px" } },
    ];

    this.versionsColumns = [ 
      {
        'key': 'versionNumber',
        'header': "",
        'style': { 'width': '20px', 'vertical-align': 'middle', 'text-align': 'right' },
        'format': (value) => { 
          return (value === this.template.restoredVersion) ? 
            `<i class="fa fa-star"title="current version" aria-label="current version"></i>` : ''; 
        }
      },
      {
        'key': 'versionNumber',
        'style': { 'width': '8ch', 'vertical-align': 'middle', 'text-align': 'center' },
        'header': "No.",
      },
      { 
        'key': 'updatedAt',
        'style': { 'width': '22ch', 'vertical-align': 'middle' },
        'header': 'Date',
        'sortable': true,
        'format': (value) =>
          `<span>${value ? new Date(value).toLocaleString("en-US", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }) : ''}</span>`
      },
      { 
        'key': 'updatedBy',
        'header': 'Author',
        'sortable': true,
        'style': { 'vertical-align': 'middle' },
      },
      { 
        'header': 'Action', 
        'key': 'versionNumber',
        'format': (value) => { return (value === this.template.restoredVersion) ? '' : `<span class='btn btn-sm btn-danger' style='font-size: 0.9rem;'>RESTORE</span>`; },
        'style': { 'width': '12ch', 'vertical-align': 'middle' },
        'onClick': (_, record) => this.versionSelected(record, false)
      },
      { 
        'header': '', 
        'key': 'versionNumber',
        'format': (value) => `<span class='btn btn-sm btn-warning' style='font-size: 0.9rem;'>CLONE</span>`,
        'style': { 'width': '12ch', 'vertical-align': 'middle' },
        'onClick': (_, record) => this.versionSelected(record, true)
      }
    ];
  }

  async $onInit() {
    const [td, granted, PROVIDER, realm] = await Promise.all([
      this.ts.getTemplateData(),
      this.ss.getGrantedDBs(),
      this.as.getProviderSettings(),
      this.as.realm(),
      this.tls.waitForLibObject("CKEDITOR")
    ]);
    this.td = td;
    this.templateId = this.ts.templateId;
    this.isDynamic = this.td.template.type === 'dynamic';
    this.loading = "";
    this.appId = this.td.template?.appId;
    this.templateApp = { 
      ...granted.find(app => app.appId === this.appId), 
      link: PROVIDER.appLinkTemplate
        .replace("[REALM]", realm)
        .replace("[APP_ID]", this.appId)};
    if (!this.td.template.restoredVersion) this.versionsColumns.shift();


    this.$timeout(()=> { this.configEditor() }, 500);

    this.loadValidationRecords(true);
    this.collapseStyles = !(this.highlightSec == '.template-background');
    this.expandMainProps = this.collapseValidations && this.collapseStyles;
    this.setBgProps();
    this.checkPasskeyField();

    this.$scope.$watch("$ctrl.tv.validationResults.SUMMARY", _ => {
      this.loadValidationRecords();
    });

    this.$scope.$watch("$ctrl.td.template.references", () => {
      this.checkPasskeyField();
    }, true);
  }

  setBgProps() {
    this.hasActionAreas = this.td.template.partialPages?.some(p => p.actionAreas?.length);
  }

  checkPasskeyField() {
    const hadPasskeyField = this.hasPasskeyField;
    this.hasPasskeyField = this.td.template.references?.some(r => r.passkeyFID) || false;
    if (this.hasPasskeyField && !hadPasskeyField) {
      this.$timeout(() => {
        if (document.getElementById('editor-passkey') && !CKEDITOR.instances['editor-passkey']) {
          const config = this.getEditorConfig();
          CKEDITOR.inline('editor-passkey', { ...CKEDITOR.config, ...config });
        }
      }, 100);
    }
  }

  loadValidationRecords(init) {
    const results = this.tv.validationResults;
    this.selectedValidation = null;
    this.validationRecords = Object.keys(results).filter(k => k != 'SUMMARY')
      .map((k, i) => {
        return {
          id: k,
          index: i,
          title: results[k].title,
          valid: results[k].valid,
          state: results[k].valid ? 'Valid' : 'Invalid',
          count: results[k].items.length,
          items: results[k].items.map(i => { return { title: i.title, id: i.id, data: i.data } }),
          resolver: results[k].resolver,
          manualAction: results[k].manualAction
        };
      }).sort((a, b) => a.title < b.title);
    this.invalidConn = this.validationRecords.find(r => r.id == "TEMPLATE_SETTINGS")?.items.some(i => i.data?.key == 'INVALID_CONN');
    this.connName = this.tv.validatedConn?.connectionName;
    this.connProps = this.template.connectionProperties.join(',');
    this.collapseValidations = !!this.highlightSec || results.SUMMARY.valid;
    init && this.collapseValidations && $("#collapseProps").collapse('show');
    this.validationPanelClass = `panel-${results.SUMMARY.level.class} || 'default'}`;
  }

  validationSelected(validationRecord) {
    if (!validationRecord.items.length) return;

    this.selectedValidation = validationRecord;
    this.validationDetailColumns = [ 
      { 
        'header': `Problems (${validationRecord.items.length})`, 
        'key': 'title',
        'tooltip': true
      },
      { 
        'header': 'Action', 
        'key': 'id',
        'tooltip': true,
        'format': (_value, _format, record) => validationRecord.resolver ? `<span class='text-danger'>${validationRecord.resolver.title}</span>`: record.data?.manualAction || validationRecord.manualAction || 'No action',
        'onClick': (_, record) => validationRecord.resolver ? validationRecord.resolver.action(record.data): null,
        'style': { "max-width": "200px", "width": "200px" }
      }
    ];
  }

  versionSelected(versionRecord, clone) {
    this.es.dispatchEvent(this.es.actions.RESTORE_TEMPLATE, { versionRecord, clone });
  }

  getEditorConfig() {
    return {
      image_previewText: ' ',
      toolbarGroups: [
        { name:"document", groups:["mode","document","doctools"] }, 
        { name:"clipboard", groups:["clipboard","undo"] },
        { name:"editing", groups:["find","selection","spellchecker"] }, 
        { name:"forms" },
        "/",
        { name:"basicstyles", groups: ["basicstyles","cleanup"] },
        { name:"paragraph", groups: ["list","indent","blocks","align","bidi"] },
        { name:"links" }, {name:"insert" },
        "/",
        { name:"styles" }, { name:"colors" }, { name:"tools" }, { name:"others" }, { name:"about" }
      ],
      removeButtons: 'About,Anchor,BidiLtr,BidiRtl,Blockquote,Button,Checkbox,CopyFormatting,CreateDiv,CreatePlaceholder,ExportPdf,Flash,Form,HiddenField,ImageButton,Language,NewPage,PageBreak,Paste,PasteFromWord,PasteText,Print,Radio,RemoveFormat,Replace,Select,ShowBlocks,Smiley,SpecialChar,Strike,Subscript,Superscript,Textarea,TextField',
      removePlugins: 'exportpdf'
    };
  }

  configEditor() {
    CKEDITOR.disableAutoInline = true;
    const config = this.getEditorConfig();
    CKEDITOR.inline('editor-success', { ...CKEDITOR.config, ...config });
    this.$timeout(() => {
      if (this.hasPasskeyField && document.getElementById('editor-passkey') && !CKEDITOR.instances['editor-passkey']) {
        CKEDITOR.inline('editor-passkey', { ...CKEDITOR.config, ...config });
      }
    }, 600);
  }

  $onDestroy() {
    if (CKEDITOR.instances['editor-success']) CKEDITOR.instances['editor-success'].destroy();
    if (CKEDITOR.instances['editor-passkey']) CKEDITOR.instances['editor-passkey'].destroy();
  }

  async handleFileSelected(rawFile, encFile) {

    if (this.ts.templateHasChanges(this.td.template)) {
      this.fs.error('Please save your changes first!');
      return;
    }

    this.messages = [];
    const msg = `Are you sure you wish to replace the Template? 
    This will rebuild all pages with selected file.`;

    if(!this.$window.confirm(msg)) { return }
    this.setMsg("File uploaded. Building Template...", "alert-info");
    this.loading = 'Building Pages...';

    const name = rawFile.name;
    const fileExt = name.split(".")[name.split(".").length - 1];
    const changeTemplateReq = {
      templateId: this.templateId,
      artifact: {
        fileExt,
        fileName: name,
        body: encFile.body,
        mimeType: rawFile.type
      }
    };

    try {
      const response = await this.tb.changeTemplate(changeTemplateReq);
      this.td.template.partialPages = response.data.template.partialPages;
      this.td.template.updatedAt = response.data.template.updatedAt;
      this.td.template.snapToFields = response.data.template.snapToFields;
      this.td.template.originalDocumentLink = response.data.template.originalDocumentLink;
      this.td.template.originalDocumentName = response.data.template.originalDocumentName;
      this.td.template.versions = response.data.template.versions;
      this.td.template.restoredVersion = response.data.template.restoredVersion;

      this.ts.notifyUpdate(["partialPages", "snapToFields", "versions", "restoredVersion"], this.td, true);
      this.setBgProps();

      this.setMsg("Template updated succesfully!", "alert-success");
    }
    catch (error) { 
      this.setMsg(error.message, "alert-danger"); 
    }

    this.loading = "";
    this.$scope.$apply();
  }


  setMsg(message, type, closeInSeconds) {
    this.messages = [{ message, "class": type, closeInSeconds }];
  }

  toggleSuccessMessageHtmlView() {
    this.showSuccessMessageHtml = !this.showSuccessMessageHtml;
  }

  togglePasskeyMessageHtmlView() {
    this.showPasskeyMessageHtml = !this.showPasskeyMessageHtml;
  }

  clearTemplateProperty(propName) {
    this.template[propName] = '';
    this.changeTemplateProperty(propName);
  }

  flipTemplateBoolField(fieldName) {
    this.template[fieldName] = !this.template[fieldName];
    this.changeTemplateProperty(fieldName);
  }

  changeTemplateProperty(prop) {
    const td = { template: {} };
    td.template[prop] = this.template[prop];
    this.ts.notifyUpdate([prop], td);
  }

  updateConnection() {
    if (this.ts.templateHasChanges(this.td.template)) {
      this.fs.error('Please save your changes first!');
      return;
    }

    const uibModal = { scope: this.$scope, size: "md", backdrop: false };
    this.connTemplate = { id: this.templateId, appId: this.appId, connectionId: this.template.connectionId  };
    uibModal.template =
      `<conn-update
          title="'Update Stored Template Connection'"
          close="$ctrl.cancelModal()"
          ignore-stored-conn="true"
          ignore-leave-confirm="$ctrl.ignoreLeaveConfirm"
          template="$ctrl.connTemplate">
        </conn-update>`;
    
    this.modal = this.$uibModal.open(uibModal);
    this.modal.result.then(
      closed => this.cancelModal(),
      canceled => this.cancelModal()
    );
  }

  cancelModal() { 
    this.modal.dismiss();
    this.$timeout(() => this.modal = null);
  }

  collapseGroupPanels(group) {
    $(`${group} .panel-collapse`).collapse('hide');
  }
}

export default {
  bindings: {
    template: "=",
    ignoreLeaveConfirm: "=?",
    highlightSec: "="
  },
  templateUrl: "form-builder/template-properties/template-properties.component.html",
  controller: TemplatePropertiesCtrl
};
